/* tslint:disable */
/* eslint-disable */
export enum WorkConnectorRunStatusEnum {
  Queued = 'queued',
  Running = 'running',
  Succeeded = 'succeeded',
  CompletedWithErrors = 'completed_with_errors',
  Failed = 'failed',
  Skipped = 'skipped'
}
